export default __webpack_public_path__ + "static/media/productour.43f2b198.svg";